module.exports = __webpack_public_path__ + "img/dateActive-icon.83dfeca9.png";